import styles from './Tag.module.css'

export type TagVariant = 'accent' | 'accent-2' | 'neutral' | 'outline'

interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: TagVariant
  className?: string
  style?: React.CSSProperties
  children: React.ReactNode
}

export function Tag({ variant = 'neutral', className = '', children, ...rest }: TagProps) {
  const { onClick, style, ...restProps } = rest
  return (
    <span
      className={`${styles.tag} ${styles[`tag-${variant}`]} ${className}`}
      style={style}
      onClick={onClick}
      {...restProps}
    >
      {children}
    </span>
  )
}
